var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultipleUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_6164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.00781 4.3125C2.00781 4.67925 2.1535 5.03097 2.41283 5.2903C2.67216 5.54963 3.02388 5.69531 3.39062 5.69531C3.75737 5.69531 4.10909 5.54963 4.36842 5.2903C4.62775 5.03097 4.77344 4.67925 4.77344 4.3125C4.77344 3.94575 4.62775 3.59403 4.36842 3.3347C4.10909 3.07537 3.75737 2.92969 3.39062 2.92969C3.02388 2.92969 2.67216 3.07537 2.41283 3.3347C2.1535 3.59403 2.00781 3.94575 2.00781 4.3125Z",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.39062 6.61719C2.77938 6.61719 2.19318 6.86001 1.76097 7.29218C1.32875 7.72442 1.08594 8.31061 1.08594 8.92188V10.3047H2.00781L2.46875 13.9922H4.3125",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2266 4.3125C11.2266 4.67925 11.3723 5.03097 11.6316 5.2903C11.8909 5.54963 12.2427 5.69531 12.6094 5.69531C12.9761 5.69531 13.3278 5.54963 13.5872 5.2903C13.8465 5.03097 13.9922 4.67925 13.9922 4.3125C13.9922 3.94575 13.8465 3.59403 13.5872 3.3347C13.3278 3.07537 12.9761 2.92969 12.6094 2.92969C12.2427 2.92969 11.8909 3.07537 11.6316 3.3347C11.3723 3.59403 11.2266 3.94575 11.2266 4.3125Z",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6094 6.61719C13.2206 6.61719 13.8068 6.86001 14.2391 7.29218C14.6712 7.72442 14.9141 8.31061 14.9141 8.92188V10.3047H13.9922L13.5312 13.9922H11.6875",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.15625 2.92969C6.15625 3.41868 6.3505 3.88764 6.69627 4.23342C7.04205 4.57919 7.51104 4.77344 8 4.77344C8.48896 4.77344 8.95795 4.57919 9.30372 4.23342C9.64948 3.88764 9.84375 3.41868 9.84375 2.92969C9.84375 2.44069 9.64948 1.97173 9.30372 1.62596C8.95795 1.28019 8.48896 1.08594 8 1.08594C7.51104 1.08594 7.04205 1.28019 6.69627 1.62596C6.3505 1.97173 6.15625 2.44069 6.15625 2.92969Z",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2266 8.92188C11.2266 8.06613 10.8866 7.24548 10.2815 6.64035C9.6764 6.03525 8.85575 5.69531 8 5.69531C7.14425 5.69531 6.32358 6.03525 5.71848 6.64035C5.11338 7.24548 4.77344 8.06613 4.77344 8.92188V10.3047H6.15625L6.61719 14.9141H9.38281L9.84375 10.3047H11.2266V8.92188Z",
    stroke: "#585858",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_6164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleUsers);
export default __webpack_public_path__ + "static/media/multiple-users.daf9a94a0c0bf898b4379f902fedfca4.svg";
export { ForwardRef as ReactComponent };